/**
 * @generated SignedSource<<3908fc25ad14b667f0fef8dabe9c63ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useFeesRelayByIdQuery$variables = {
  id: string;
};
export type useFeesRelayByIdQuery$data = {
  readonly getFee: {
    readonly activeOn: any;
    readonly amount: number;
    readonly appliedAboveSubTotalThreshold: number | null | undefined;
    readonly appliedPostTax: boolean;
    readonly appliedToMembers: boolean;
    readonly appliedUnderSubTotalThreshold: number | null | undefined;
    readonly archivedOn: any | null | undefined;
    readonly createdOn: any;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly organizationId: string | null | undefined;
    readonly system: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly systemId: string;
  } | null | undefined;
};
export type useFeesRelayByIdQuery = {
  response: useFeesRelayByIdQuery$data;
  variables: useFeesRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Fee",
    "kind": "LinkedField",
    "name": "getFee",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "archivedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliedPostTax",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliedToMembers",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliedAboveSubTotalThreshold",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliedUnderSubTotalThreshold",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "System",
        "kind": "LinkedField",
        "name": "system",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oldId",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFeesRelayByIdQuery",
    "selections": (v3/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFeesRelayByIdQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "fe4bc282bd0b5014205245046d1a25f3",
    "id": null,
    "metadata": {},
    "name": "useFeesRelayByIdQuery",
    "operationKind": "query",
    "text": "query useFeesRelayByIdQuery(\n  $id: ID!\n) {\n  getFee(id: $id) {\n    id\n    name\n    amount\n    description\n    activeOn\n    archivedOn\n    appliedPostTax\n    appliedToMembers\n    appliedAboveSubTotalThreshold\n    appliedUnderSubTotalThreshold\n    systemId\n    organizationId\n    createdOn\n    system {\n      id\n      oldId\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f636f6a48bd576a2d4cd92bbf76cfa98";

export default node;
